import React from 'react'

 const HIghlightedText = ({text}) => {
  return (
    <div className='font-bold text-xl flex md:text-2xl text-blue-400 '>
        {text}
    </div>
  )
}

export default HIghlightedText;